import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Briefcase, Mail } from 'lucide-react';
import { Button } from '@/components/ui/button';

const CareersPage = () => {
  const { i18n } = useTranslation();

  return (
    <main className="min-h-screen pt-20 pb-16">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center py-16"
        >
          <div className="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-6">
            <Briefcase className="w-10 h-10 text-primary" />
          </div>
          
          <h1 className="text-4xl font-bold mb-4">
            {i18n.language === 'fr' ? 'Carrières' : 'Careers'}
          </h1>
          
          <p className="text-xl text-muted-foreground mb-8">
            {i18n.language === 'fr' 
              ? 'Rejoignez l\'aventure XPerience'
              : 'Join the XPerience adventure'}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="bg-gray-50 rounded-2xl p-12 text-center"
        >
          <div className="w-16 h-16 rounded-full bg-gray-200 flex items-center justify-center mx-auto mb-6">
            <Briefcase className="w-8 h-8 text-gray-400" />
          </div>
          
          <h2 className="text-2xl font-semibold text-gray-700 mb-4">
            {i18n.language === 'fr' 
              ? 'Pas de postes ouverts actuellement'
              : 'No open positions currently'}
          </h2>
          
          <p className="text-muted-foreground mb-8 max-w-md mx-auto">
            {i18n.language === 'fr'
              ? 'Nous n\'avons pas de postes à pourvoir pour le moment, mais n\'hésitez pas à nous envoyer une candidature spontanée !'
              : 'We don\'t have any open positions at the moment, but feel free to send us a spontaneous application!'}
          </p>

          <div className="bg-white rounded-xl p-6 max-w-md mx-auto border">
            <h3 className="font-semibold mb-2">
              {i18n.language === 'fr' ? 'Candidature spontanée' : 'Spontaneous application'}
            </h3>
            <p className="text-sm text-muted-foreground mb-4">
              {i18n.language === 'fr'
                ? 'Envoyez-nous votre CV et lettre de motivation'
                : 'Send us your CV and cover letter'}
            </p>
            <Button variant="outline" asChild>
              <a href="mailto:careers@xperience-guides.com">
                <Mail className="w-4 h-4 mr-2" />
                careers@xperience-guides.com
              </a>
            </Button>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="mt-12 text-center"
        >
          <h3 className="text-xl font-semibold mb-4">
            {i18n.language === 'fr' ? 'Pourquoi rejoindre XPerience ?' : 'Why join XPerience?'}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
            {[
              {
                title: i18n.language === 'fr' ? 'Impact' : 'Impact',
                desc: i18n.language === 'fr' 
                  ? 'Contribuez à transformer le tourisme local'
                  : 'Help transform local tourism'
              },
              {
                title: i18n.language === 'fr' ? 'Équipe' : 'Team',
                desc: i18n.language === 'fr'
                  ? 'Une équipe passionnée et bienveillante'
                  : 'A passionate and caring team'
              },
              {
                title: i18n.language === 'fr' ? 'Croissance' : 'Growth',
                desc: i18n.language === 'fr'
                  ? 'Opportunités d\'apprentissage et d\'évolution'
                  : 'Learning and growth opportunities'
              }
            ].map((item, index) => (
              <div key={index} className="bg-white rounded-xl p-6 border">
                <h4 className="font-semibold text-primary mb-2">{item.title}</h4>
                <p className="text-sm text-muted-foreground">{item.desc}</p>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </main>
  );
};

export default CareersPage;
